export class intakeTimeValueModel {
    startDate: number =0;
    duration: number = 0;
}